import { render, staticRenderFns } from "./PressDifAlarmSet.vue?vue&type=template&id=5f88ebd4&scoped=true"
import script from "./PressDifAlarmSet.vue?vue&type=script&lang=js"
export * from "./PressDifAlarmSet.vue?vue&type=script&lang=js"
import style0 from "./PressDifAlarmSet.vue?vue&type=style&index=0&id=5f88ebd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f88ebd4",
  null
  
)

export default component.exports